import {NavLink} from "react-router-dom";
import {ADMIN_SECTION_NAV, type AdminSectionId} from "@/lib/adminSectionNav";
import {cn} from "@/lib/utils";
import {Badge} from "@/components/ui/badge";

type Props = {
  section: AdminSectionId;
  badges?: Record<string, number>;
  className?: string;
};

export function AdminSectionTabs({section, badges, className}: Props) {
  const config = ADMIN_SECTION_NAV[section];
  return (
    <nav
      className={cn(
        "admin-section-tabs overflow-x-auto rounded-2xl border border-border/60 bg-card/80 p-2 shadow-sm backdrop-blur-sm",
        className
      )}
      aria-label={`${config.title} navigation`}
    >
      <div className="flex min-w-max gap-2 px-1 py-1">
        {config.tabs.map((tab) => {
          const count = tab.badgeKey ? badges?.[tab.badgeKey] : undefined;
          return (
            <NavLink
              key={tab.href}
              to={tab.href}
              end={tab.end}
              className={({isActive}) => cn(
                "relative inline-flex items-center gap-2.5 whitespace-nowrap rounded-xl px-5 py-3 text-sm font-medium transition-all duration-200",
                isActive
                  ? "bg-primary text-primary-foreground shadow-md shadow-primary/20"
                  : "text-muted-foreground hover:bg-muted/70 hover:text-foreground"
              )}
            >
              {({isActive}) => (
                <>
                  {tab.label}
                  {count != null && count > 0 ? (
                    <Badge className={cn(
                      "h-5 min-w-5 justify-center rounded-full border-0 px-1.5 text-[11px] font-semibold tabular-nums",
                      isActive ? "bg-primary-foreground/20 text-primary-foreground" : "bg-muted text-foreground"
                    )}>
                      {count}
                    </Badge>
                  ) : null}
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
